export default "__VITE_ASSET__yV4fupLc__"